/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { UPDATE_MY_PROFILE } from '@pages/MyProfilePage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/MyProfilePage/config/api.config';

import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  name: string;
  description: string;
  email: string;
  phoneNumber: string;
  address: string;
  website: string;
}

export class UpdateProfilePlugin implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    return await this.updateProfile(args);
  }

  private async updateProfile(args: UpdateProfileProps) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_MY_PROFILE, {
          input: {
            ...args,
          },
        })
        .toPromise();

      if (res?.data?.updateMyProfile) {
        return {
          data: res?.data?.updateMyProfile,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
